import { createAsyncThunk } from '@reduxjs/toolkit';
import { UpdateUserStatusRequestDto, UserRequestDto, UserResponseDto } from 'shared/api';
import { usersApi } from '../../api/usersApi';

export const getUsers = createAsyncThunk(
  'users/getUsers',
  async (params: { email?: string; status?: UserResponseDto.status; company?: string } = {}) => {
    const response = await usersApi.getUsers(params.email, params.status, params.company);
    return response;
  },
);

export const getUserById = createAsyncThunk(
  'users/getUserById',
  async (id: number) => {
    const response = await usersApi.getUserById(id);
    return response;
  },
);

// Удалены несуществующие методы API

export const createUser = createAsyncThunk(
  'users/createUser',
  async (data: UserRequestDto) => {
    const response = await usersApi.createUser(data);
    return response;
  },
);

export const updateUser = createAsyncThunk(
  'users/updateUser',
  async ({ id, data }: { id: number; data: UserRequestDto }) => {
    const response = await usersApi.updateUser(id, data);
    return response;
  },
);

export const updateUserStatus = createAsyncThunk(
  'users/updateUserStatus',
  async ({ id, status }: { id: number; status: UpdateUserStatusRequestDto.status }) => {
    const response = await usersApi.updateUserStatus(id, status);
    return response;
  },
);

export const deleteUser = createAsyncThunk(
  'users/deleteUser',
  async (id: number) => {
    await usersApi.deleteUser(id);
    return id;
  },
);
